import React, { useState } from 'react';
import './Navbar.css';
import logo from '../img/bazurtologo.png';
import { Link, useLocation } from 'react-router-dom';

function Navbar({ activeSection, isScrolled }) { // Receive isScrolled prop
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Determine classes based on page and scroll state
  const navbarClasses = [
    'navbar',
    isHomePage && isScrolled ? 'navbar-scrolled' : '', // Use isScrolled prop
    !isHomePage ? 'navbar-solid' : '', // Apply solid background on other pages
  ].filter(Boolean).join(' ');



  return (
    <nav className={navbarClasses}> 
      <div className="navbar-container"> 
        <div className="navbar-left">
          <Link to="/">
            {/* Add conditional class to the logo */}
            <img src={logo} alt="Yo Amo Bazurto Logo" className={`navbar-logo ${isScrolled || !isHomePage ? 'visible' : 'hidden'}`} />
          </Link>
        </div>
        <div className={`navbar-right ${isMobileMenuOpen ? 'open' : ''}`}>
          {/* Conditional rendering for links based on current page */}
          {isHomePage ? (
            <a href="#home" className={activeSection === 'home' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Inicio</a>
          ) : (
            <Link to="/#home" className={activeSection === 'home' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Inicio</Link>
          )}
          
          {isHomePage ? (
            <a href="#experiencias" className={activeSection === 'experiencias' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Experiencias</a>
          ) : (
            <Link to="/#experiencias" className={activeSection === 'experiencias' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Experiencias</Link>
          )}

          <Link to="/#reservas" className={activeSection === 'reservas' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Reservas</Link>

          <Link to="/#menu" className={activeSection === 'menu' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Menú</Link>

          {isHomePage ? (
            <a href="#salones" className={activeSection === 'salones' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Salones</a>
          ) : (
            <Link to="/#salones" className={activeSection === 'salones' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Salones</Link>
          )}

          {isHomePage ? (
            <a href="#resenas" className={activeSection === 'resenas' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Reseñas</a>
          ) : (
            <Link to="/#resenas" className={activeSection === 'resenas' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Reseñas</Link>
          )}

          <Link to="/eventos" className={activeSection === 'eventos' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Eventos</Link>

          {isHomePage ? (
            <a href="#contacto" className={activeSection === 'contacto' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Contacto</a>
          ) : (
            <Link to="/#contacto" className={activeSection === 'contacto' ? 'active' : ''} onClick={() => setIsMobileMenuOpen(false)}>Contacto</Link>
          )}
        </div>
        <div className="mobile-buttons">
          <button className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <span className="hamburger-icon"></span>
          </button>
          <Link to="/reservas" className="mobile-reservas-button">Reservas</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;